import { render, staticRenderFns } from "./ChildRegistrationTask.vue?vue&type=template&id=2b28f574&scoped=true"
import script from "./ChildRegistrationTask.vue?vue&type=script&lang=ts"
export * from "./ChildRegistrationTask.vue?vue&type=script&lang=ts"
import style0 from "./ChildRegistrationTask.vue?vue&type=style&index=0&id=2b28f574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b28f574",
  null
  
)

export default component.exports